import { useState } from "react";
import { ChevronDown, ChevronUp } from "react-feather";

import Collapse from "../../../../../shared/Collapse/Collapse";

// Reusable collapsible shell for a single monthly challenge (ReBet, Referral,
// Casino, ...). Presentational only — the body content is supplied by the
// caller so each challenge type can compose its own progress bar + history.

const STATUS_TONE_CLASS = {
  "in-progress": "user-manager-game-pass-monthly-status--in-progress",
  completed: "user-manager-game-pass-monthly-status--completed",
  "not-started": "user-manager-game-pass-monthly-status--not-started",
};

const MonthlyChallengeCard = ({
  title,
  subtitle,
  counterLabel,
  tierLabel,
  status,
  defaultOpen = false,
  testId = "monthly-challenge-card",
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const toneClass = status ? STATUS_TONE_CLASS[status.tone] ?? "" : "";

  return (
    <section
      className="user-manager-game-pass-monthly-card"
      data-testid={testId}
    >
      <button
        type="button"
        className="user-manager-game-pass-monthly-card-header"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        data-testid={`${testId}-toggle`}
      >
        <span className="user-manager-game-pass-monthly-card-titles">
          <span className="user-manager-game-pass-monthly-card-title">
            {title}
          </span>
          {subtitle && (
            <span className="user-manager-game-pass-monthly-card-subtitle">
              {subtitle}
            </span>
          )}
        </span>
        <span className="user-manager-game-pass-monthly-card-meta">
          {counterLabel && (
            <span
              className="user-manager-game-pass-monthly-card-counter"
              data-testid={`${testId}-counter`}
            >
              {counterLabel}
            </span>
          )}
          {tierLabel && (
            <span
              className="user-manager-game-pass-monthly-card-tier"
              data-testid={`${testId}-tier-label`}
            >
              {tierLabel}
            </span>
          )}
          {status && (
            <span
              className={`user-manager-game-pass-monthly-status ${toneClass}`.trim()}
              data-testid={`${testId}-status`}
            >
              {status.label}
            </span>
          )}
          <span
            className="user-manager-game-pass-monthly-card-chevron"
            aria-hidden="true"
          >
            {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </span>
        </span>
      </button>
      <Collapse open={open} data-testid={`${testId}-collapse`}>
        <div
          className="user-manager-game-pass-monthly-card-body"
          data-testid={`${testId}-body`}
        >
          {children}
        </div>
      </Collapse>
    </section>
  );
};

export default MonthlyChallengeCard;
